import { create } from 'zustand';
import type { TutorSession } from '../types/tutor';

interface SessionState {
  currentSession: TutorSession | null;
  sessionHistory: TutorSession[];
  setCurrentSession: (session: TutorSession | null) => void;
  addToHistory: (session: TutorSession) => void;
  clearHistory: () => void;
}

export const useSessionStore = create<SessionState>((set) => ({
  currentSession: null,
  sessionHistory: [],
  setCurrentSession: (session) => set({ currentSession: session }),
  addToHistory: (session) =>
    set((state) => ({ sessionHistory: [...state.sessionHistory, session] })),
  clearHistory: () => set({ sessionHistory: [] }),
}));
